import React from 'react'
import styled from 'styled-components'
import { font, ink, labelStyle } from 'features/dashboard/tokens'

const SectionTitle = ({ children, eyebrow, hint, action }) => (
  <Block>
    {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
    <Wrapper>
      <Text>{children}</Text>
      {hint && <Hint>{hint}</Hint>}
      {action && <Action>{action}</Action>}
    </Wrapper>
  </Block>
)

export default SectionTitle

const Block = styled.div`
  margin-bottom: 12px;
`

const Eyebrow = styled.span`
  ${labelStyle}
  display: block;
  padding-left: 14px;
  margin-bottom: 4px;
`

const Wrapper = styled.div`
  display: flex;
  align-items: baseline;
  gap: 12px;
`

const Text = styled.h2`
  font-family: 'FuturaPT-Light', system-ui, sans-serif;
  font-weight: normal;
  letter-spacing: -0.5px;
  font-size: ${font.title};
  color: ${({ theme }) => theme.colors.haiti};
  margin: 0;
  border-left: 4px solid ${({ theme }) => theme.colors.secondary};
  padding-left: 10px;
`

const Hint = styled.span`
  font-size: ${font.small};
  color: ${ink.mute};
  margin-left: auto;
`

const Action = styled.span`
  display: inline-flex;
  align-items: center;
  margin-left: auto;
`
